import { createAsyncThunk } from "@reduxjs/toolkit";
const createAppAsyncThunk = createAsyncThunk.withTypes();
export {
  createAppAsyncThunk
};
